import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { Product, ColorFilter } from 'src/app/modals/product.model';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'
import { trigger } from '@angular/animations';
import { oUser } from 'src/app/modals/user';
import { AccountService } from 'src/app/components/shared/services/account.service';



@Component({
  selector: 'app-product-left-sidebar',
  templateUrl: './product-left-sidebar.component.html',
  styleUrls: ['./product-left-sidebar.component.sass'],
  animations: [
    trigger('Animation', [

    ]),
  ]
})
export class ProductLeftSidebarComponent implements OnInit {
  public sidenavOpen:boolean = true;
  public animation    :   any;   // Animation
  public sortByOrder  :   string = '';   // sorting
  public page:any;
  public tagsFilters  :   any[] = [];
  public viewType: string = 'grid';
  public viewCol: number = 25;
  public filterForm: FormGroup;
  public colorFilters :   ColorFilter[] = [];

  public items        :   Product[] = [];
  public allItems: Product[] = [];
  public products: Product[] = [];
  public productsFiltrados: Product[] = [];
  public tags         :   any[] = [];
  public colors       :   any[] = [];
  public classifications         :   any[] = [];
  public brands         :   any[] = [];
  public category;
  public contentLoaded : boolean = false;
  public user:oUser;
  public title:string = "Shop";
  public nodata:boolean = false;

  public brandsSelected:any[]=[];
  public clasifSelected:any[]=[];
  
  constructor(private productService: ProductService, 
              private route: ActivatedRoute,
              private router: Router,
              private accountService :AccountService ) {
                
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {



          this.user = this.accountService.getAccount();          
          this.category = this.route?.snapshot?.paramMap?.get("category");


          if (this.category!=0){
            this.productService.getProductByCategoryID(this.category).subscribe(res => {

                this.nodata = true;
                this.allItems = [];
                this.products = [];
                if (res.payload!=null){
                  for (var product of res.payload) {
                    this.allItems.push(this.productService.toProducto(product,this.user?.cliBonif || 0));
                  }
                  this.nodata = false;
                }
                this.products = Array.from(this.allItems);
                this.productsFiltrados = Array.from(this.allItems);
                this.title = "Shop / " + res.extras;
                this.getClasificaciones(this.allItems);
                this.getMarcas(this.allItems);
               

                this.contentLoaded=true;
            })
          }else{
            this.route.queryParams.subscribe(params => {
             
              console.log("aca miro el producto",params);

              const menuRedefinido =
                params['menuRedefinido'] === true || params['menuRedefinido'] === 'true';
              const textoBusqueda = params['string'] || params['textoBusqueda'] || '';

              this.productService.getProductByName(textoBusqueda, menuRedefinido).subscribe(res => {
                this.title = 'Buscar / ' + textoBusqueda;
                this.nodata = true;
                this.allItems = [];

                if (res.payload!=null){
                  for (var product of res.payload) {
                      this.allItems.push(this.productService.toProducto(product,this.user?.cliBonif || 0));
                  }            
                  this.nodata = false;
                }
                this.products = Array.from(this.allItems);
                this.getClasificaciones(this.allItems);
                this.getMarcas(this.allItems);
                this.contentLoaded=true;
            })

            });

          }


  }




      public getMarcas(products) {
        var uniqueClass = []
        products.map((product, idx) => {
          const index = uniqueClass.findIndex(item => item.marMarcaId === product.brandid);
          if(index === -1)  uniqueClass.push({marMarcaId:product.brandid,
                                              marDescripcion:product.brand});
        });
        this.brands = uniqueClass;
        this.brandsSelected = [];
      }

      public getClasificaciones(products) {
        var uniqueClass = []
        products.map((product, idx) => {
          if (product.claClasificacionId!==0 && 
              product.claDescripcion !== '' && 
              product.claClasificacionId !== null && 
              product.claDescripcion !==null ){
                 const index = uniqueClass.findIndex(item => item.claClasificacionId === product.claClasificacionId);
                if(index === -1)  uniqueClass.push({claClasificacionId:product.claClasificacionId,
                                                    claDescripcion:product.claDescripcion});     
          }
        });
        this.classifications = uniqueClass;
      }

     // Get current product tags
     public getTags(products) {
      var uniqueBrands = []
      var itemBrand = Array();
      products.map((product, index) => {
         if(product.tags) {
            product.tags.map((tag) => {
            const index = uniqueBrands.indexOf(tag);
            if(index === -1)  uniqueBrands.push(tag);
         })
        }
      });
      for (var i = 0; i < uniqueBrands.length; i++) {
           itemBrand.push({brand:uniqueBrands[i]})
      }
      this.tags = itemBrand
   }

     // Get current product colors
     public getColors(products) {
      var uniqueColors = []
      var itemColor = Array();
      products.map((product, index) => {
        if(product.colors) {
        product.colors.map((color) => {
            const index = uniqueColors.indexOf(color);
            if(index === -1)  uniqueColors.push(color);
        })
       }
      });
      for (var i = 0; i < uniqueColors.length; i++) {
           itemColor.push({color:uniqueColors[i]})
      }
      this.colors = itemColor
    }





  public changeViewType(viewType, viewCol){
    this.viewType = viewType;
    this.viewCol = viewCol;
  }
    // Animation Effect fadeIn
    public fadeIn() {
      this.animation = 'fadeIn';
  }

  // Animation Effect fadeOut
  public fadeOut() {
      this.animation = 'fadeOut';
  }

    // Update tags filter
    public updateTagFilters(tags: any[]) {
      this.tagsFilters = tags;
      this.animation == 'fadeOut' ? this.fadeIn() : this.fadeOut(); // animation
  }



    // sorting type ASC / DESC / A-Z / Z-A etc.
    public onChangeSorting(val) {
      this.sortByOrder = val;
      this.animation == 'fadeOut' ? this.fadeIn() : this.fadeOut(); // animation
   }

     // Initialize filetr Items
  public filterItems(): Product[] {
    return this.items.filter((item: Product) => {
        const Colors: boolean = this.colorFilters.reduce((prev, curr) => { // Match Color
          if(item.colors){
            if (item.colors.includes(curr.color)) {
              return prev && true;
            }
          }
        }, true);
        const Tags: boolean = this.tagsFilters.reduce((prev, curr) => { // Match Tags
          if(item.tags) {
            if (item.tags.includes(curr)) {
              return prev && true;
            }
          }
        }, true);
        return Colors && Tags; // return true
    });

}

public onPageChanged(event){
  this.page = event;
  this.allItems;
  window.scrollTo(0,0);
}


  // Update price filter
//   public updatePriceFilters(price: any) {
//     let items: any[] = [];
//     this.products.filter((item: Product) => {
//         if (item.price >= price[0] && item.price <= price[1] )  {
//            items.push(item); // push in array
//         }
//     });
//     this.items = items;
// }


  // Update price filter
  public updatePriceFilters(price: any) {
   this.allItems = this.products.filter((item: Product) => {
     return item.price >= price.priceFrom && item.price <= price.priceTo
    });
  }

    onclasifChanged(filterClasif:any[]){
      this.clasifSelected = filterClasif;
      if (filterClasif.length==0){
              this.products = this.allItems;
              return;
      }
      let uniqueProd:Product[]=[];
      let arr_to_add:Product[]=[];
      for (var j = 0; j < filterClasif.length; j++) {
              arr_to_add = this.allItems.filter((item) => item.claClasificacionId == filterClasif[j].claClasificacionId);
              for (var i = 0; i < arr_to_add.length; i++) {
                  if (uniqueProd.indexOf(arr_to_add[i]) === -1) uniqueProd.push(arr_to_add[i]);
              } 
      }
      this.productsFiltrados = Array.from(uniqueProd);
      this.products = uniqueProd;
      this.getMarcas(this.products);
     

    }

    onBrendsChanged(newBrend:any[]) {
      
      if  (this.brandsSelected.length > newBrend.length || newBrend.length==0){
           this.onclasifChanged(this.clasifSelected);
           return;
      }

      this.brandsSelected = newBrend;
      if (newBrend.length==0){
              this.products = this.productsFiltrados;
              return;
      }
      let uniqueProd:Product[]=[];
      let arr_to_add:Product[]=[];
      for (var j = 0; j < newBrend.length; j++) {
              arr_to_add = this.productsFiltrados.filter((item) => item.brandid == newBrend[j].marMarcaId);
              for (var i = 0; i < arr_to_add.length; i++) {
                  if (uniqueProd.indexOf(arr_to_add[i]) === -1) uniqueProd.push(arr_to_add[i]);
              } 
      }
      this.products = uniqueProd;
    }
}

